export default "__VITE_ASSET__Dkd0fuSF__"